import {
    FETCH_ORDER,
    FETCH_ORDER_FAILURE,
    FETCH_ORDER_SUCCESS,
} from 'store/actions/types';

// Fetch Orders
export const fetchOrder = (payload) => {
    return {
        type: FETCH_ORDER,
        payload: payload,
    };
};

export const fetchOrderFailure = (error) => {
    return {
        type: FETCH_ORDER_FAILURE,
        error: error,
    };
};

export const fetchOrderSuccess = (response) => {
    return {
        type: FETCH_ORDER_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/orders/fetchOrders.js